export default "__VITE_ASSET__GzQGwcDu__"